<form [formGroup]="loginForm">
    <div class="login-body">
        <p-messages></p-messages>
        <p-toast key="tst"></p-toast>
        <div class="login-wrapper">
            <div class="login-panel">
                <a [routerLink]="['/']" class="logo">
                    <img src="assets/ck-capital-finance-logo.png" alt="CK Logo" />
                </a>
                <div class="login-form pt-5">
                    <h2>Login</h2>
                    <!-- <p>You don't have an account? <a href="#"> Sign up</a></p> -->
                    <input id="username" type="text"  formControlName="username" autocomplete="off" pInputText placeholder="Email">
                    <input id="password" type="password"  formControlName="password" autocomplete="off" pInputText placeholder="Password">
                    <button *ngIf="logIn && !needsPassword" pButton pRipple label="LOGIN" icon="pi pi-key" (click)="signIn()" type="submit"><i *ngIf="signingIn" class="pi pi-spin pi-spinner"></i></button>
                    <button *ngIf="needsPassword" [disabled]="resettingPassword"  icon="pi pi-key" id="ForgotPasswordButton" pButton pRipple label="FORGOT PASSWORD" type="submit" (click)="forgotPassword()" ><i *ngIf="resettingPassword" class="pi pi-spinner pi-spin"></i></button>
                </div>
    
                <p>Forgot Your Password? <a href="" onclick="return false;" (click)="showForgotPassword()">Reset Here</a></p>
            </div>
        </div>
    </div>
</form>

<p-dialog [(visible)]="showTotpDialog" [closeOnEscape]="false" [closable]="false">
    <ng-template pTemplate="header">
        <h4>Confirm Two-Factor Authentication Code</h4>
    </ng-template>
    <div class="card" style="text-align:center">
        <p>Open your authenticator app and enter your time based code.</p>
        <input id="TotpCodeInput" (keydown.enter)="confirmTotp()" pInputText placeholder="Authenticator App Code" [(ngModel)]="totpCode">
    </div>
    <p-footer>
        <button pButton type="button" class="p-button-danger" label="Cancel" icon="pi pi-times" (click)="hideTotpCodeDialog()"></button>
        <button [disabled]="confirmingTotp" pButton type="submit" (keydown.enter)="confirmTotp()" class="p-button-success" label="Confirm" icon="pi pi-check" (click)="confirmTotp()"><i *ngIf="confirmingTotp" class="pi pi-spinner pi-spin"></i></button>
    </p-footer>
</p-dialog>

<p-dialog [(visible)]="showResetPasswordDialog" [closeOnEscape]="false" [closable]="false">
    <ng-template pTemplate="header">
        <h4>Reset Your Password</h4>
    </ng-template>
    <div class="card" style="text-align:center">
        <p>Enter the verification code sent to your email in order to reset your password</p>
        <div class="p-fluid">
            <input *ngIf="!newPasswordRequired" id="CodeInput" pInputText (keydown.enter)="confirmResetPassword()" placeholder="Verification Code" class="mb-2" [(ngModel)]="code">
            <input pInputText type="password" (keydown.enter)="confirmResetPassword()" class="mb-2" placeholder="New Password" [(ngModel)]="newPassword">
            <input pInputText type="password" (keydown.enter)="confirmResetPassword()" class="mb-2" placeholder="Re-Enter New Password" [(ngModel)]="newPasswordAgain">
        </div>
        
    </div>
    <p-footer>
        <button pButton type="button" class="p-button-danger" label="Cancel" icon="pi pi-times" (click)="hideResetPasswordDialog()"></button>
        <button [disabled]="resettingPassword" pButton type="button" class="p-button-success" label="Confirm" icon="pi pi-check" (click)="confirmResetPassword()"><i *ngIf="resettingPassword" class="pi pi-spinner pi-spin"></i></button>
    </p-footer>
</p-dialog>
